module.exports = __webpack_public_path__ + "assets/media/day21.76bd701f.mp3";